import {
  Box,
  Button,
  makeStyles,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import PropTypes from 'prop-types';
import { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PAGE_SIZE_LIST } from 'src/app/constant/config';
import SearchInput from '../../../components/input/SearchInput';
import CreateGeocodeSource from './CreateGeocodeSource';
import { reloadGeocode } from 'src/features/geocodeSlice';
import axios from 'src/app/axiosInterceptor';

const Toolbar = ({ searchRef }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [query, setQuery] = useState({
    keywords: undefined,
    page: 1,
    page_size: PAGE_SIZE_LIST
  });
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [openStatusModal, setOpenStatusModal] = useState(false);
  const [statusData, setStatusData] = useState(null);
  const [statusLoading, setStatusLoading] = useState(false);

  const supportedTypes = useSelector(state => state.geocodeSlice.supportedTypes);

  const handleSearchChange = useCallback((value) => {
    setQuery(prevQuery => ({
      ...prevQuery,
      keywords: value || undefined,
      page: 1
    }));
  }, []);

  const handleSearch = useCallback((value) => {
    setQuery(prevQuery => {
      const newQuery = {
        ...prevQuery,
        keywords: value || undefined,
        page: 1
      };
      if (searchRef) {
        searchRef(newQuery);
      }
      return newQuery;
    });
  }, [searchRef]);

  const handleOpenCreateModal = useCallback(() => {
    setOpenCreateModal(true);
  }, []);

  const closeModal = useCallback(() => {
    setOpenCreateModal(false);
  }, []);

  const handleReload = useCallback(() => {
    dispatch(reloadGeocode({}));
  }, [dispatch]);

  const handleOpenStatus = useCallback(() => {
    setOpenStatusModal(true);
    setStatusLoading(true);
    axios.get('/geocode/status')
      .then(res => {
        setStatusData(res.data?.payload || res.data);
        setStatusLoading(false);
      })
      .catch(() => {
        setStatusData(null);
        setStatusLoading(false);
      });
  }, []);

  const closeStatusModal = useCallback(() => {
    setOpenStatusModal(false);
    setStatusData(null);
  }, []);

  return (
    <div className={classes.root}>
      {openCreateModal &&
      (<CreateGeocodeSource
        open={openCreateModal}
        onClose={closeModal}
        supportedTypes={supportedTypes}
      />)}
      {openStatusModal && (
        <Dialog
          open={openStatusModal}
          onClose={closeStatusModal}
          maxWidth="md"
          fullWidth
          PaperProps={{
            style: { borderRadius: 8, minHeight: '300px' }
          }}
        >
          <DialogTitle>
            <Typography variant="h6" style={{ fontSize: '18px', fontWeight: 600 }}>
              Trạng thái hệ thống Geocode
            </Typography>
          </DialogTitle>
          <DialogContent>
            {statusLoading ? (
              <Typography>Đang tải...</Typography>
            ) : statusData ? (
              <Box>
                {statusData?.sources && statusData.sources.length > 0 ? (
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ borderBottom: '1px solid #ddd' }}>
                        <th style={{ padding: '8px', textAlign: 'left' }}>Nguồn</th>
                        <th style={{ padding: '8px', textAlign: 'left' }}>Trạng thái</th>
                        <th style={{ padding: '8px', textAlign: 'left' }}>Số lần gọi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {statusData.sources.map((s, idx) => (
                        <tr key={idx} style={{ borderBottom: '1px solid #eee' }}>
                          <td style={{ padding: '8px' }}>{s.name || s.type || '-'}</td>
                          <td style={{ padding: '8px' }}>
                            <span style={{
                              color: s.breaker_state === 'closed' ? '#4caf50' : s.breaker_state === 'open' ? '#f44336' : '#ff9800',
                              fontWeight: 500
                            }}>
                              {s.breaker_state || '-'}
                            </span>
                          </td>
                          <td style={{ padding: '8px' }}>{s.calls ?? '-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <Typography>Không có dữ liệu trạng thái</Typography>
                )}
                {statusData?.cache && (
                  <Box mt={2}>
                    <Typography variant="subtitle2">Cache</Typography>
                    <pre style={{ fontSize: '12px', background: '#f5f5f5', padding: '8px', borderRadius: '4px' }}>
                      {JSON.stringify(statusData.cache, null, 2)}
                    </pre>
                  </Box>
                )}
              </Box>
            ) : (
              <Typography>Lỗi tải dữ liệu trạng thái</Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={closeStatusModal} className="btn-main btn-plain" variant="contained" color="primary">
              Đóng
            </Button>
          </DialogActions>
        </Dialog>
      )}
      <Box>
        <Box className={classes.groupSearch}>
          <div className={classes.groupSearchLeft}>
            <Typography
              style={{ fontSize: '24px', fontWeight: '600', color: '#0C1132' }}
            >
              Quản trị bản đồ
            </Typography>
          </div>
          <Box
            style={{
              marginLeft: '10px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '15px'
            }}
          >
            <Box>
              <SearchInput
                value={query.keywords || ''}
                onChange={handleSearchChange}
                onSearch={handleSearch}
                className={'searchInputDevice'}
                placeholder="Tìm kiếm..."
              />
            </Box>
            {/* Nút viền nằm trên nền trắng: ép màu chữ trắng là tự làm nó tàng hình.
                Để palette tô — "secondary" ra chữ đỏ, cùng tông với nút chính. */}
            <Button
              className={classes.styleInputSearch}
              variant="outlined"
              color="secondary"
              onClick={handleReload}
            >
              Reload ingress
            </Button>
            <Button
              className={classes.styleInputSearch}
              variant="outlined"
              color="primary"
              onClick={handleOpenStatus}
            >
              Trạng thái
            </Button>
            <Button
              style={{ color: '#ffff' }}
              className={classes.styleInputSearch}
              color="secondary"
              variant="contained"
              onClick={handleOpenCreateModal}
            >
              Thêm nguồn
            </Button>
          </Box>
        </Box>
      </Box>
    </div>
  );
};

Toolbar.propTypes = {
  className: PropTypes.string
};

const useStyles = makeStyles(theme => ({
  root: {},
  importButton: {
    marginRight: theme.spacing(1)
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative'
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  groupSearch: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minWidth: '50%'
  },
  groupSearchLeft: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  searchInput: {
    width: '250px'
  },
  styleInputSearch: {
    height: '39px',
    textTransform: 'none',
    padding: '0px 1em'
  },
  exportBtn: {
    justifyContent: 'flex-end',
    display: 'flex',
    paddingTop: '10px',
    paddingBottom: '10px'
  },
  shadowBox: {
    boxShadow: '0 2px 5px rgba(0,0,0,.18)'
  }
}));

export default Toolbar;